/* HEAVYS / Visually Desktop JS - Patented 8-Speaker */
(function () {
  "use strict";

  const fallbackItems = [
    {
      title: "8-Speaker Architecture",
      desc: "Four Dedicated Speakers Per Ear Reveal Layers Traditional Headphones Miss And Deliver Exceptional Detail, Frequency Separation, And Depth Of Sound.",
    },
    {
      title: "Natural Immersive Sound Field",
      desc: "Sound Interacts With Your Outer Ear Before Reaching The Eardrum For A More Lifelike Experience And Minimal Listening Fatigue. We Built HEAVYS Tech Around How Humans Naturally Hear Sound.",
    },
    {
      title: "Front-Facing Tweeters",
      desc: "Positioned In Front Of The Ear For Improved Directionality, Clarity, And Realism.",
    },
    {
      title: "Dual Woofers",
      desc: "Cleaner, Punchier Bass With Lower Distortion Even At High Volumes. Feel The Powerful Low-End Without Sacrificing The Detail In Vocals, Guitars, And Drums.",
    },
    {
      title: "Ultra-Comfort Ear Pads",
      desc: "Replaceable Ear Pads With Pressure-Distributing Foam For Long Listening Sessions.",
    },
    {
      title: "50-Hour Battery Life",
      desc: "Power Through Playlists, Workdays, And Travel Without Reaching For A Charger. Listen For Days, Not Hours, On A Single Charge.",
    },
    {
      title: "Wired And Wireless",
      desc: "Switch Seamlessly Between High-Fidelity Wired Listening And Wireless Freedom.",
    },
    {
      title: "Custom Replaceable EarCup Covers",
      desc: "Celebrate Your Favorite Art And Music With Collectible SHELL Designs. Swap Shells To Fit Your Mood, Your Music, Or Your Style And Make HEAVYS Truly Yours.",
    },
  ];

  function getItems(section) {
    const root = section.closest("[data-visually-speaker-root]") || document;
    const jsonEl = root.querySelector("[data-visually-speaker-items]");
    if (!jsonEl) return fallbackItems;

    try {
      const parsed = JSON.parse(jsonEl.textContent);
      if (Array.isArray(parsed) && parsed.length) return parsed;
    } catch (e) {}

    return fallbackItems;
  }

  let started = false;

  function getSection() {
    return document.querySelector(
      ".visually-speaker-section[data-visually-speaker]"
    );
  }

  function buildMarkup(accordion, items) {
    accordion.innerHTML = items
      .map(function (item, index) {
        const isActive = index === 0;

        return `
          <div class="speaker-item ${
            isActive ? "active" : ""
          }" data-index="${index}">
            <button class="speaker-button" type="button" data-index="${index}">
              <span class="speaker-number">${index + 1}</span>
              <span class="speaker-title">${item.title}</span>
              <span class="speaker-icon">${isActive ? "-" : "+"}</span>
            </button>
            <div class="speaker-desc">${item.desc}</div>
          </div>
        `;
      })
      .join("");
  }

  function setActive(section, activeIndex) {
    section.querySelectorAll(".speaker-item").forEach(function (item, index) {
      const isActive = index === activeIndex;
      item.classList.toggle("active", isActive);

      const icon = item.querySelector(".speaker-icon");
      if (icon) icon.textContent = isActive ? "-" : "+";
    });

    section
      .querySelectorAll(".speaker-hotspot")
      .forEach(function (hotspot, index) {
        hotspot.classList.toggle("active", index === activeIndex);
      });
  }

  function bindEvents(section) {
    section.addEventListener("click", function (event) {
      const trigger =
        event.target.closest && event.target.closest("[data-index]");
      if (!trigger || !section.contains(trigger)) return;

      const index = Number(trigger.getAttribute("data-index"));
      if (!Number.isNaN(index)) setActive(section, index);
    });
  }

  function render() {
    const section = getSection();
    if (!section) return false;

    const accordion = section.querySelector("#speakerAccordion");
    if (!accordion) return false;

    // Prefer server-rendered accordion to avoid empty→filled layout jump
    if (!accordion.querySelector(".speaker-item")) {
      buildMarkup(accordion, getItems(section));
    }

    if (!started) {
      started = true;
      bindEvents(section);
    }

    return true;
  }

  function init() {
    if (render()) return;

    let tries = 0;
    const timer = setInterval(function () {
      if (render() || ++tries > 40) clearInterval(timer);
    }, 250);

    if (window.MutationObserver) {
      const observer = new MutationObserver(function () {
        if (render()) observer.disconnect();
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
      setTimeout(function () {
        observer.disconnect();
      }, 12000);
    }
  }

  if (document.readyState !== "loading") {
    init();
  } else {
    document.addEventListener("DOMContentLoaded", init);
  }
})();

/* HEAVYS / Visually Mobile JS - Patented 8-Speaker */
(function () {
  "use strict";

  const fallbackItems = [
    {
      title: "8-Speaker Architecture",
      desc: "Four Dedicated Speakers Per Ear Reveal Layers Traditional Headphones Miss And Deliver Exceptional Detail, Frequency Separation, And Depth Of Sound.",
    },
    {
      title: "Natural Immersive Sound Field",
      desc: "Sound Interacts With Your Outer Ear Before Reaching The Eardrum For A More Lifelike Experience And Minimal Listening Fatigue. We Built HEAVYS Tech Around How Humans Naturally Hear Sound.",
    },
    {
      title: "Front-Facing Tweeters",
      desc: "Positioned In Front Of The Ear For Improved Directionality, Clarity, And Realism.",
    },
    {
      title: "Dual Woofers",
      desc: "Cleaner, Punchier Bass With Lower Distortion Even At High Volumes. Feel The Powerful Low-End Without Sacrificing The Detail In Vocals, Guitars, And Drums.",
    },
    {
      title: "Ultra-Comfort Ear Pads",
      desc: "Replaceable Ear Pads With Pressure-Distributing Foam For Long Listening Sessions.",
    },
    {
      title: "50-Hour Battery Life",
      desc: "Power Through Playlists, Workdays, And Travel Without Reaching For A Charger. Listen For Days, Not Hours, On A Single Charge.",
    },
    {
      title: "Wired And Wireless",
      desc: "Switch Seamlessly Between High-Fidelity Wired Listening And Wireless Freedom.",
    },
    {
      title: "Custom Replaceable EarCup Covers",
      desc: "Celebrate Your Favorite Art And Music With Collectible SHELL Designs. Swap Shells To Fit Your Mood, Your Music, Or Your Style And Make HEAVYS Truly Yours.",
    },
  ];

  function getItems(section) {
    const root = section.closest("[data-visually-speaker-root]") || document;
    const jsonEl = root.querySelector("[data-visually-speaker-items]");
    if (!jsonEl) return fallbackItems;

    try {
      const parsed = JSON.parse(jsonEl.textContent);
      if (Array.isArray(parsed) && parsed.length) return parsed;
    } catch (e) {}

    return fallbackItems;
  }

  function initMobile() {
    const section = document.querySelector(
      ".visually-speaker-section:not([data-visually-speaker])"
    );
    const mobileTrack = section
      ? section.querySelector("#speakerMobileTrack")
      : null;
    const mobileDots = section
      ? section.querySelector("#speakerMobileDots")
      : null;

    if (!section || !mobileTrack) return;

    const items = getItems(section);
    const hotspots = section.querySelectorAll(".speaker-hotspot");

    mobileTrack.innerHTML = items
      .map(function (item, index) {
        const isActive = index === 0;

        return `
        <article class="speaker-mobile-card ${
          isActive ? "active" : ""
        }" data-index="${index}">
          <div class="speaker-mobile-card-header">
            <span class="speaker-mobile-number">${index + 1}</span>
            <h3 class="speaker-mobile-title">${item.title}</h3>
          </div>
          <p class="speaker-mobile-desc">${item.desc}</p>
        </article>
      `;
      })
      .join("");

    if (mobileDots) {
      mobileDots.innerHTML = items
        .map(function (_, index) {
          return `
          <button
            class="speaker-mobile-dot ${index === 0 ? "active" : ""}"
            type="button"
            data-index="${index}"
            aria-label="Show speaker feature ${index + 1}"
          ></button>
        `;
        })
        .join("");
    }

    function scrollMobileCard(activeIndex) {
      const card = mobileTrack.querySelector(
        `.speaker-mobile-card[data-index="${activeIndex}"]`
      );
      if (!card) return;

      const trackPaddingLeft =
        parseFloat(window.getComputedStyle(mobileTrack).paddingLeft) || 0;

      mobileTrack.scrollTo({
        left: card.offsetLeft - trackPaddingLeft,
        behavior: "smooth",
      });
    }

    function setActive(activeIndex, shouldScrollMobile) {
      hotspots.forEach(function (hotspot, index) {
        hotspot.classList.toggle("active", index === activeIndex);
      });

      section
        .querySelectorAll(".speaker-mobile-card")
        .forEach(function (card, index) {
          card.classList.toggle("active", index === activeIndex);
        });

      section
        .querySelectorAll(".speaker-mobile-dot")
        .forEach(function (dot, index) {
          dot.classList.toggle("active", index === activeIndex);
        });

      if (shouldScrollMobile) scrollMobileCard(activeIndex);
    }

    section.addEventListener("click", function (event) {
      const trigger = event.target.closest("[data-index]");
      if (!trigger || !section.contains(trigger)) return;

      const index = Number(trigger.getAttribute("data-index"));
      if (!Number.isNaN(index)) setActive(index, true);
    });

    mobileTrack.addEventListener("scroll", function () {
      window.requestAnimationFrame(function () {
        const cards = Array.from(
          mobileTrack.querySelectorAll(".speaker-mobile-card")
        );
        const trackPaddingLeft =
          parseFloat(window.getComputedStyle(mobileTrack).paddingLeft) || 0;
        const activeCard = cards.reduce(function (closest, card) {
          const distance = Math.abs(
            card.offsetLeft - mobileTrack.scrollLeft - trackPaddingLeft
          );
          if (!closest || distance < closest.distance)
            return { card: card, distance: distance };
          return closest;
        }, null);

        if (!activeCard) return;

        const index = Number(activeCard.card.getAttribute("data-index"));
        if (!Number.isNaN(index)) setActive(index, false);
      });
    });
  }

  if (document.readyState !== "loading") {
    initMobile();
  } else {
    document.addEventListener("DOMContentLoaded", initMobile);
  }
})();
